import React, { useState } from "react";
import { Form, AutoComplete } from "antd";
import {
  GetJobTemplateTitleInfo,
  GetPostAJobTitles,
} from "../../../pages/api/Employer/Employer";
import { createUseStyles } from "react-jss";

const UISelectCompleteInput = ({
  style = {},
  FieldType,
  label,
  name,
  required,
  rules,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  defaultValue,
  placeholder = "",
  option = []
}) => {

  const arr = [];
  Object.values(option).map((item , key) => {
    let obj = {};
    obj["value"] = item;
    obj["FieldId"] = key;
    arr.push(obj);
  });

  const [options, setOptions] = useState(arr);
  const handleSearch = (value) => {
    let res = [];
    // serach if not found add new option
    options.forEach((item) => {
        if (item.value.indexOf(value) > -1) {
            res.push(item);
        }
    });

    if(value && res.length === 0 ) {
        res.push({ value: value, id: 0 });

    }
    setOptions(res);
  };

  const styles = useStyles();

  return (
    <Form.Item
      label={ <span style={{ fontSize: "16px" , fontWeight: "500" }}>{label}</span>  }
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue =="" ? [] : defaultValue}
    >

      <AutoComplete
          // onSearch={handleSearch}
          options={options}
          allowClear
          className={styles.customSelect}
          style={{ padding: "12px 10px !important" , fontSize: '16px' , fontWeight: "500" , ...style , height: "50px !important" }}
          placeholder={placeholder}
          disabled={disabled}
      />
    </Form.Item>
  );
};

export default UISelectCompleteInput;
const useStyles = createUseStyles({
  customSelect : {
    marginBottom: 10,
    '& .ant-select-selector': {
      minHeight: 50,
      height: 'auto',
      padding: '6px 10px',
      fontSize: 16,
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  }
});